export default __webpack_public_path__ + "static/Connect-6811b362b652ae8604abf311cc952688.png";